import * as React from "react";

function SvgMap(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path clipRule="evenodd" d="M7.163 1.556A4.608 4.608 0 003.905 9.42l2.857 2.857a.57.57 0 00.803 0l2.857-2.857a4.607 4.607 0 00-3.259-7.865zM3.74 1.039a6.163 6.163 0 017.783 9.482l-2.857 2.856a2.126 2.126 0 01-3.003 0l-2.857-2.856A6.164 6.164 0 013.74 1.04zM7.163 4.92a1.242 1.242 0 100 2.484 1.242 1.242 0 000-2.484zm-1.978-.736a2.797 2.797 0 113.956 3.956 2.797 2.797 0 01-3.956-3.956z" /></svg>;
}

export default SvgMap;